module.exports = __webpack_public_path__ + "15-o2.jpg?cf45626bfc1e315c014c711e5cc3fc2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/15-o2.jpg
// module id = 629
// module chunks = 0